import { combineReducers } from "redux";
import { Action } from "../actions/types";
import authUserReducer from "./authUserReducer";
import branchReducer from "./branchReducer";
import { employeeAttendanceReducer } from "./employeeAttendanceReducer";
import { employeeReducer } from "./employeeReducer";
import { employeeAttachmentReducer } from "./empAttachReducer";
import { salaryReducer } from "./empSalaryReducer";
import { salaryMasterReducer } from "./salaryMasterReducer";
import projectReducer from "./projectReducer";
import holidayReducer from "./holidayReducer";
import { leaveRequestReducer } from "./leaveRequestReducer";
import { sprintReducer } from "./sprintReducer";
import { moduleReducer } from "./moduleReducer";
import { subModuleReducer } from "./subModuleReducer";
import { leaveTransactionReducer } from "./leaveTransactionReducer";
import { taskLogReducer } from "./taskLogReducer";
import { taskAttachmentReducer } from "./taskAttachmentReducer";
import { taskCommentReducer } from "./taskCommentReducer";
import { empReportReducer } from "./empReportReducer";
import taskReducer from "./taskReducer";
import { dropDownReducer } from "./dropdownReducer";
import { salaryMasterLogReducer } from "./salaryMasterLogReducer";
import { forgotPasswordReducer } from "./forgotPasswordReducer";
import { pageReducer } from "./pageReducer";
import roleReducer from "./roleReducer";

// Combine reducers
const combinedReducers = combineReducers({
  authUser: authUserReducer,
  branch: branchReducer,
  dropDown: dropDownReducer,
  employeeAttendance: employeeAttendanceReducer,
  employee: employeeReducer,
  employeeAttachment: employeeAttachmentReducer,
  employeeSalary: salaryReducer,
  salaryMaster: salaryMasterReducer,
  project: projectReducer,
  holiday: holidayReducer,
  leaveRequest: leaveRequestReducer,
  sprint: sprintReducer,
  module: moduleReducer,
  subModule: subModuleReducer,
  leaveTransaction: leaveTransactionReducer,
  taskLog: taskLogReducer,
  taskAttachment: taskAttachmentReducer,
  taskComment: taskCommentReducer,
  employeeReport: empReportReducer,
  task: taskReducer,
  dropdown: dropDownReducer,
  salaryMasterLog: salaryMasterLogReducer,
  forgotPassword: forgotPasswordReducer,
  page: pageReducer,
  role:roleReducer,
});

// Reducer function
const reducers = (state: StoreState | undefined, action: Action) => {
  return combinedReducers(state, action);
};

// Types
export type StoreState = ReturnType<typeof combinedReducers>;
export type GetState = () => StoreState;

export default reducers;
